import { FC } from 'react';

import { IconProps } from '../../shared/ui';

export const CloudsIcon: FC<IconProps> = ({ width = 48, height = 48, fillBg = '#828282', fill = '#63656A' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="10" fill={fillBg} />
      <g clipPath="url(#clip0_218_2675)">
        <path
          d="M24 7.63672C15.168 7.63672 8 14.8047 8 23.6367C8 32.4687 15.168 39.6367 24 39.6367C32.832 39.6367 40 32.4687 40 23.6367C40 14.8047 32.832 7.63672 24 7.63672ZM31.2 30.0367H17.6C14.944 30.0367 12.8 27.8927 12.8 25.2367C12.8 22.5807 14.944 20.4367 17.6 20.4367L17.824 20.4527C18.1698 19.0767 18.9652 17.8555 20.0841 16.983C21.203 16.1105 22.5812 15.6367 24 15.6367C27.536 15.6367 30.4 18.5007 30.4 22.0367H31.2C32.2609 22.0367 33.2783 22.4581 34.0284 23.2083C34.7786 23.9584 35.2 24.9759 35.2 26.0367C35.2 27.0976 34.7786 28.115 34.0284 28.8651C33.2783 29.6153 32.2609 30.0367 31.2 30.0367Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_218_2675">
          <rect width="32" height="32" fill="white" transform="translate(8 7.63672)" />
        </clipPath>
      </defs>
    </svg>
  );
};
